import React from 'react'
import { get } from 'lodash'
import { IoIosDocument } from 'react-icons/io'
import JsonDisplay from '../../common/JsonDisplay'

function ArgumentsDisplay(record, column) {
  return (
    <div>
      {record.file_url
        && <a href={record.file_url} target="_blank" rel="noopener noreferrer"><IoIosDocument size={20} /></a>}
      {JsonDisplay(get(record, column.key))}
    </div>
  )
}

export default ArgumentsDisplay
